import moment from 'moment'

/**
 * Returns `now` (in the UTC offset of `date_from`) when `date_from` is in the past and the window has not ended, otherwise `date_from`.
 */
export const clampDateFromToNow = (
  date_from: string,
  date_until: string,
  now: moment.Moment
): string =>
  moment(date_from).isBefore(now) && !moment(date_until).isBefore(now)
    ? now.clone().utcOffset(moment.parseZone(date_from).utcOffset()).format()
    : date_from
